import { enableProdMode } from "@angular/core";
import { bootstrapApplication } from "@angular/platform-browser";

import { AppConfig } from "environments/environment";
import { AppComponent } from "screens/app/app.component";
import { appConfig } from "screens/app/app.config";

if (AppConfig.production) enableProdMode();

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
